<code-input
  class="col-md-7"
  #codeInput
  [codeLength]="4"
  [code]="initialCode"
  (codeChanged)="onCodeChanged($event)"
  (focusout)="onBlur($event)"
>
</code-input>
